export default __webpack_public_path__ + "static/media/alert-info-icon-black.e825f886.svg";